'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { PaginationComponent } from './component';
import {FormsModule} from '@angular/forms';
import {LKIcon} from '../icon/module';

@NgModule({
  imports     : [
    BrowserModule,
    FormsModule,
    LKIcon
  ],
  declarations: [PaginationComponent],
  exports     : [PaginationComponent]
})
export class LKPagination {
}
